const oidc = {
    logout_success: 'Sessão terminada com sucesso.',
};
export default Object.freeze(oidc);
